import TPRScreen from "../../components/ipd/tpr/TPRScreen";

function TPR() {
  return <TPRScreen />;
}

export default TPR;
